module.exports = __webpack_public_path__ + "img/verify7.2db401e7.png";